export class GenerateTSOReportInput {
    orderIds: number[];
}